import { proposalsService } from '@/services';
import type { ProposalCategories } from '@/services/proposals/types';
import { useQuery } from '@tanstack/react-query';

interface UseProposalSchemaOptions {
  enabled?: boolean;
}

export function useProposalSchema(
  category: ProposalCategories | undefined,
  options: UseProposalSchemaOptions = {}
) {
  const { enabled = true } = options;
  const shouldRun = Boolean(enabled && category != null);

  return useQuery({
    queryKey: ['proposal-schema', category ?? '__pending__'],
    queryFn: async () => {
      if (category == null) {
        throw new Error('Categoria de schema não definida');
      }
      const response = await proposalsService.getSchema(category);

      if (!response.success || !response.data) {
        throw new Error(response.error || 'Erro ao carregar schema');
      }

      return response.data;
    },
    staleTime: 1000 * 60 * 5,
    enabled: shouldRun,
  });
}
